/**
 * 将时间戳（秒）格式化为日期字符串
 * @param timestamp 秒级时间戳，如 1752562068
 * @param showTime 是否显示时分，默认为 true
 * @returns 格式化后的日期字符串
 */
const formatTimestamp = (timestamp: number, showTime = true): string => {
  if (!timestamp && timestamp !== 0) return '';
  const date = new Date(timestamp * 1000);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  if (showTime) {
    const hour = pad(date.getHours());
    const minute = pad(date.getMinutes());
    return `${year}-${month}-${day} ${hour}:${minute}`;
  }

  return `${year}-${month}-${day}`;
};

const stringToArray = (str: string): string[] => {
  if (!str) return [];
  return str.split(',');
};

export { formatTimestamp, stringToArray };
